import { useState } from 'react'
import { useSensor, useSensors } from '@dnd-kit/core'

import {
  DRAG_DROP_DEFAULT_CONFIG,
  DRAG_DROP_MEASURING_DEFAULT_PROPS,
  DRAG_DROP_OVERLAY_DEFAULT_PROPS,
} from '../DragDrop.constants'
import { DragDropContextProvider } from '../DragDropContextProvider'
import { DndOverlay } from '../DragDropOverlay'

function DragDropProvider({
  activationDistance = DRAG_DROP_DEFAULT_CONFIG.activationDistance,
  children,
  collisionDetection = DRAG_DROP_DEFAULT_CONFIG.collisionDetection, // Collision detection decides which droppable is considered "over"
  dndContextProps,
  keyboardCodes,
  keyboardCoordinateGetter = DRAG_DROP_DEFAULT_CONFIG.keyboardCoordinateGetter,
  measuring = DRAG_DROP_MEASURING_DEFAULT_PROPS,
  overlayProps = DRAG_DROP_OVERLAY_DEFAULT_PROPS,
  renderOverlay,
  onDragCancel,
  onDragEnd,
  onDragOver,
  onDragStart,
  ...restProps
}) {
  const pointerSensor = useSensor(DRAG_DROP_DEFAULT_CONFIG.sensors.pointer, {
    activationConstraint: { distance: activationDistance },
  })

  const keyboardSensor = useSensor(DRAG_DROP_DEFAULT_CONFIG.sensors.keyboard, {
    coordinateGetter: keyboardCoordinateGetter,
    keyboardCodes,
  })

  const sensors = useSensors(pointerSensor, keyboardSensor)

  // Track activeId to render an optional DragOverlay preview
  const [activeId, setActiveId] = useState(null)
  const [activeData, setActiveData] = useState(null)

  function handleDragStart(e) {
    setActiveId(e.active.id)
    setActiveData(e.active?.data?.current || null)

    onDragStart?.(e)
  }

  function handleDragEnd(e) {
    setActiveId(null)
    setActiveData(null)

    onDragEnd?.(e)
  }

  function handleDragCancel(e) {
    setActiveId(null)
    setActiveData(null)

    onDragCancel?.(e)
  }

  function handleDragOver(e) {
    onDragOver?.(e)
  }

  const contextProps = {
    ...dndContextProps,
    collisionDetection,
    measuring,
    sensors,
    onDragCancel: handleDragCancel,
    onDragEnd: handleDragEnd,
    onDragOver: handleDragOver,
    onDragStart: handleDragStart,
  }

  return (
    <div {...restProps}>
      <DragDropContextProvider {...contextProps}>
        {children}
        <DndOverlay {...overlayProps}>
          {activeId && renderOverlay
            ? renderOverlay(activeId, activeData)
            : null}
        </DndOverlay>
      </DragDropContextProvider>
    </div>
  )
}

export default DragDropProvider
